// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const vullaby: PokeData = {
  "id": 629,
  "name": "vullaby",
  "height": 5,
  "weight": 90,
  "base_experience": 74,
  "types": [
    PokeType.DARK,
    PokeType.FLYING
  ],
  "api_moves": [
    "gust",
    "whirlwind",
    "fury-attack",
    "leer",
    "mirror-move",
    "feint-attack",
    "attract",
    "flatter",
    "knock-off",
    "iron-defense",
    "pluck",
    "tailwind",
    "embargo",
    "punishment",
    "dark-pulse",
    "air-slash",
    "brave-bird",
    "nasty-plot",
    "defog"
  ],
  "moves": [
    "gust",
    "leer",
    "flatter",
    "tailwind",
    "dark-pulse",
    "air-slash",
    "brave-bird",
    "hurricane",
    "roost",
    "pursuit",
    "night-slash",
    "phantom-force",
    "crunch"
  ],
  "evolution_chain": {
    "id": 320,
    "item": null,
    "species": [
      {
        "name": "vullaby",
        "order": 630,
        "types": [
          PokeType.DARK,
          PokeType.FLYING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "mandibuzz",
        "order": 631,
        "types": [
          PokeType.DARK,
          PokeType.FLYING
        ],
        "evolves_from_species_id": 629,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 54,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 70,
    "speed": 60,
    "ability_power": 55
  },
  "stat_changes": [],
  "catch_rate": 190,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
